<!-- This is not the best template patter, but as we need to create arrows for the popover, we need to create a wrapper for the popover content and the arrow. 
This way we can control the position of the arrow and the popover content. -->
<div
  #popoverContent
  popover
  [style.width]="popoverWidth() + 'px'"
  [style.top]="topPosition()"
  [style.left]="leftPosition()"
  [ngClass]="{ 'top-wrapper': placement() === 'bottom', 'bottom-wrapper': placement() === 'top' }"
>
  @if (placement() === 'bottom') {
    <div class="arrow-top"></div>
  }
  <div class="popover-container" [ngClass]="{ top: placement() === 'bottom', bottom: placement() === 'top' }">
    <button
      class="close"
      type="button"
      aria-label="Close"
      [ngClass]="{ 'close-bottom': placement() === 'top' }"
      (click)="closePopover()"
    >
      <svg width="14" height="14" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M31.6093 0.391667C31.7335 0.515506 31.832 0.662622 31.8992 0.824589C31.9664 0.986555 32.001 1.16019 32.001 1.33555C32.001 1.5109 31.9664 1.68454 31.8992 1.84651C31.832 2.00847 31.7335 2.15559 31.6093 2.27943L2.2797 31.609C2.02937 31.8594 1.68985 32 1.33582 32C0.981801 32 0.642277 31.8594 0.391944 31.609C0.141612 31.3587 0.000976563 31.0192 0.000976562 30.6652C0.000976563 30.3111 0.141612 29.9716 0.391944 29.7213L29.7216 0.391667C29.8454 0.267514 29.9925 0.169013 30.1545 0.101804C30.3164 0.0345952 30.4901 0 30.6654 0C30.8408 0 31.0144 0.0345952 31.1764 0.101804C31.3384 0.169013 31.4855 0.267514 31.6093 0.391667Z"
          i18n-d
          fill="#0A2240"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.391667 0.391667C0.267514 0.515506 0.169013 0.662622 0.101804 0.824589C0.0345952 0.986555 0 1.16019 0 1.33555C0 1.5109 0.0345952 1.68454 0.101804 1.84651C0.169013 2.00847 0.267514 2.15559 0.391667 2.27943L29.7213 31.609C29.9716 31.8594 30.3111 32 30.6652 32C31.0192 32 31.3587 31.8594 31.609 31.609C31.8594 31.3587 32 31.0192 32 30.6652C32 30.3111 31.8594 29.9716 31.609 29.7213L2.27943 0.391667C2.15559 0.267514 2.00847 0.169013 1.84651 0.101804C1.68454 0.0345952 1.5109 0 1.33555 0C1.16019 0 0.986555 0.0345952 0.824589 0.101804C0.662622 0.169013 0.515506 0.267514 0.391667 0.391667Z"
          i18n-d
          fill="#0A2240"
        />
      </svg>
    </button>
    <ng-content />
  </div>
  @if (placement() === 'top') {
    <div class="arrow-bottom"></div>
  }
</div>
